import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { css } from 'styled-components'
import dsTheme from '../constants/design-system/theme.json'

import Button from '../components/Button'
import CenteredButton from '../components/styles/CenteredButton'
import DataDiscountPlans from '../components/DataDiscountPlans'
import DataRolloverHero from '../components/DataRolloverHero'
import DataRolloverBody from '../components/DataRolloverBody'
import DataRolloverStats from '../components/DataRolloverStats'
import FullWidthContainer from '../components/styles/FullWidthContainer'
import Padding from '../components/styles/Padding'
import SEO from '../components/Seo'
import SiteContainer from '../components/styles/SiteContainer'
import { WhySmartyPlans } from '../components/WhySmarty/WhySmarty'
import withApp from '../components/withApp/withApp'
import PlanSection from '../components/PlanSection'

import AllPlans from '../modular-system/AllPlans'
import Quote from '../modular-system/Quote'

import { progressiveBreakpoints } from '../constants/theme'
import { HideOnTablet } from '../components/styles/Responsive'

const { colors } = dsTheme

const seoMeta = {
  title: 'Data rollover has just got better with SMARTY',
  description:
    'SMARTY knocks money off your bill for the data you haven’t used. Unlike other data rollover plans which builds up.',
}

const dataRolloverContent = {
  heroPlansCta: 'View our other plans',
  discountPlansCta: 'View our data discount plans',
  planSectionTitle: 'Hungry for more data?',
}

const styledContainer = css`
  position: relative;
  overflow: hidden;
`

const styledQuote = css`
  padding: 1.3rem 0 3.5rem;

  @media ${progressiveBreakpoints.desktopSmall} {
    max-width: 618px;
    padding-top: 4.5rem;
    padding-bottom: 0;
  }

  blockquote {
    font-size: 1.125rem;
    line-height: 1.44;

    @media ${progressiveBreakpoints.tablet} {
      font-size: 2.125rem;
      line-height: 1.12;
    }
  }
`

const DataRollover = ({ plans: { plans } }) => (
  <Fragment>
    <SEO title={seoMeta.title} description={seoMeta.description} />

    <FullWidthContainer
      css={styledContainer}
      background={colors['Brand/PrimaryBlack']}
    >
      <SiteContainer>
        <HideOnTablet>
          <Padding size={2.5} sizeDesktop={2.5} /> {/* 40px - */}
        </HideOnTablet>
        <DataRolloverHero />
        <Padding size={1.25} sizeDesktop={2.5} /> {/* 40px desktop */}
        <DataDiscountPlans plans={plans} />
        <CenteredButton noMargin>
          <Button
            href="#plans"
            color={colors['Brand/PrimaryGreen']}
            data-item-category="LP"
            data-item-name="data-rollover-plans-card-view-other-plans"
            data-testid="view-other-plans-button"
          >
            {dataRolloverContent.heroPlansCta}
          </Button>
        </CenteredButton>
        <Padding size={2.5} sizeDesktop={5} /> {/* 80px */}
      </SiteContainer>
    </FullWidthContainer>

    <FullWidthContainer
      css={styledContainer}
      background={colors['UI/DarkGrey']}
    >
      <SiteContainer>
        <Padding size={1.25} sizeDesktop={2.5} />{' '}
        {/* 40px - the DataRolloverBody has its own padding */}
        <DataRolloverBody />
        <Padding size={2.5} sizeDesktop={5} /> {/* 80px */}
        <DataRolloverStats />
        <Quote
          data-testid="customer-quote"
          text="My monthly bill is under £6 because of the data discount."
          source="James White, Trustpilot"
          css={styledQuote}
        />
        <CenteredButton>
          <Button
            href="#data-discount-plans"
            color={colors['Brand/PrimaryGreen']}
            data-item-category="LP"
            data-item-name="data-rollover-halfway-view-data-discount-plans"
            data-testid="view-our-data-discount-plans-button"
          >
            {dataRolloverContent.discountPlansCta}
          </Button>
        </CenteredButton>
        <Padding size={1.25} sizeDesktop={2.5} />
      </SiteContainer>
    </FullWidthContainer>

    <FullWidthContainer background={colors['Brand/PrimaryBlack']}>
      <SiteContainer>
        <Padding size={1.25} sizeDesktop={2.5} />
        <AllPlans
          hasIcon
          headerTestId="all-plans-include-title"
          listTestId="all-plans-include-list-item"
          iconTestId="all-plans-check-icon"
        />
        <WhySmartyPlans />
        <Padding size={2.5} sizeDesktop={5} />
      </SiteContainer>
    </FullWidthContainer>

    <FullWidthContainer
      background={colors['UI/DarkGrey']}
      // rgba value as the design has opacity 0.4
      // TODO: add rgba values to design system
      desktopBackground="rgba(51,53,57,0.4)"
    >
      <SiteContainer>
        <PlanSection
          extraTitle={dataRolloverContent.planSectionTitle}
          plans={plans}
          hideDataDiscountPlans
          hideCoverageChecker
          hasChecklist={false}
        />

        <CenteredButton noMargin>
          <Button
            href="#data-discount-plans"
            color={colors['Brand/PrimaryGreen']}
            data-item-category="LP"
            data-item-name="data-rollover-footer-view-data-discount-plans"
            data-testid="view-data-discount-plans-button"
          >
            {dataRolloverContent.discountPlansCta}
          </Button>
        </CenteredButton>
        <Padding size={2.5} sizeDesktop={5} />
      </SiteContainer>
    </FullWidthContainer>
  </Fragment>
)

DataRollover.propTypes = {
  plans: PropTypes.object,
}

export default withApp(DataRollover)
